import { combineLatest, from } from 'rxjs';
import { driveDatabase } from '../../app/database/drive.database';
import { Injectable } from '@angular/core';
import { PhotoRequestRecord, RequestRecord, RetryStatus } from './request.interface';
import { liveQuery } from 'dexie';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  hasAnyRequestWithStatus$(status: RetryStatus) {
    return from(
      liveQuery(() =>
        Promise.all([
          driveDatabase.requests
            .where('retry.status')
            .equals(status)
            .count()
            .then((count) => count > 0),
          driveDatabase.photoRequests
            .where('retry.status')
            .equals(status)
            .count()
            .then((count) => count > 0)
        ]).then((hasRequests) => hasRequests.some(Boolean))
      )
    );
  }

  getAllRequestsReactive() {
    return from(driveDatabase.getAllRequestsReactive());
  }

  hasRequestsReactive() {
    return from(liveQuery(() => driveDatabase.hasRequests()));
  }

  hasPhotoRequestsReactive() {
    return from(liveQuery(() => driveDatabase.hasPhotoRequests()));
  }

  hasRequestsOrPhotoRequests() {
    return combineLatest([this.hasPhotoRequests(), this.hasRequests()]).pipe(
      map(([hasRequests, hasPhotoRequests]) => hasRequests || hasPhotoRequests)
    );
  }

  private hasRequests() {
    return from(driveDatabase.hasRequests());
  }

  private hasPhotoRequests() {
    return from(driveDatabase.hasPhotoRequests());
  }

  retry(requestRecord: RequestRecord) {
    return from(driveDatabase.retryRequestById(requestRecord.entity.id));
  }

  getAllPhotoRequestsReactive() {
    return from(driveDatabase.getAllPhotoRequestsReactive());
  }

  getAllPhotoRequestsWithStatus$(status: RetryStatus) {
    return from(liveQuery(() => driveDatabase.photoRequests.where('retry.status').equals(status).toArray()));
  }

  retryPhoto(photoRequest: PhotoRequestRecord) {
    return from(driveDatabase.retryPhotoRequestById(photoRequest.photo.id));
  }
}
